import React, { useEffect, useState, useRef } from 'react';
import api from '../../api';
import FlightCard from '../card/FlightCard';
import Aereo from '../../assets/icone/card/aereiColore.svg';
import CategoryCarousel from '../../components/utils/CategoryCarousel';
import { useTranslation } from 'react-i18next';

const FlightCarousel = () => {
  const [tickets, setTickets] = useState([]);
  const { t } = useTranslation();
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return; // Se già eseguito, esce
    didFetch.current = true;

    const fetchFlights = async () => {
      try {
        const response = await api.get('/reservations/flights/active');
        setTickets(response.data.activeItems);
      } catch (error) {
      }
    };

    fetchFlights();
  }, []);

  const renderFlightCard = (ticket) => (
    <FlightCard ticket={ticket} user={ticket.user_id} />
  );

  return (
    <CategoryCarousel
      items={tickets}
      categoryIcon={Aereo}
      categoryTitle={t('travel.flightReservation')}
      renderCard={renderFlightCard}
      category="flights"
    />
  );
};

export default FlightCarousel;
